import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";
import { CrmQuote } from "./crmService";

const api = new APIClient();

export const getPublicQuote = async (token: string): Promise<CrmQuote> => {
  const response = await api.get(
    `/public/quotes/${encodeURIComponent(token)}`
  ) as ApiResponse<CrmQuote>;
  return response.data;
};

export const acceptPublicQuote = async (
  token: string
): Promise<{
  quote: CrmQuote;
  order_id: number;
  studio_message: string;
  next_steps?: string;
}> => {
  const response = await api.create(
    `/public/quotes/${encodeURIComponent(token)}/accept`,
    {}
  ) as ApiResponse<{
    quote: CrmQuote;
    order_id: number;
    studio_message: string;
    next_steps?: string;
  }>;
  return response.data;
};
